import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';
import { generatePath } from 'react-router';

import Withdraws from 'api/resources/withdraws';
import { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import SocialLinks from 'admin-moderator/components/SocialLinks';
import TransactionTooltip from 'admin-moderator/components/TransactionTooltip';

import Avatar from 'components/Avatar';
import Checkbox from 'components/Checkbox';
import Name from 'styled/ItemCard/Name';
import SimpleLink from 'styled/SimpleLink';
import UserItemRow from 'styled/UserItemRow';
import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';

export class UserRow extends React.PureComponent {
  state = { loading: false }

  get selected() {
    if (!this.props.history || !this.props.history.location || !this.props.history.location.pathname) return false;

    return this.props.history.location.pathname.indexOf(this.props.id) !== -1;
  }

  get generatedPath() {
    return generatePath(
      '/biller/:department/status/:status/:requestId/user/:userId',
      {
        ...this.props.match.params,
        requestId: this.props.id,
        userId: this.props.userId,
      }
    );
  }

  handleRejectClick = () => {
    this.updateStatus('rejected');
  }

  handleProcessingClick = () => {
    this.updateStatus('processing');
  }

  updateStatus = async (status) => {
    this.setState({ loading: true });

    try {
      const response = await Withdraws.patch({
        withdrawId: this.props.id,
        body: {
          data: {
            type: 'withdraw',
            attributes: { status },
          },
        },
      });

      const withdraw = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.props.onStatusUpdate(withdraw);

      Alert.success(status === 'rejected' ? 'Запрос отклонен' : 'Запрос одобрен');
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <UserItemRow selected={this.selected}>
        <div style={{ marginTop: '9px' }}>
          {this.props.match.params.status === 'created'
            ? (
              <Checkbox
                id={this.props.id}
                checked={this.props.isChecked}
                onChange={this.props.onCheckboxChange}
                toggle
                disabled={this.props.disabled}
              />
            )
            : <div style={{ width: '24px' }} />
          }
        </div>

        <div style={{ display: 'flex' }}>
          <SimpleLink to={this.generatedPath}>
            <Avatar
              size="56px"
              name={this.props.name}
              fontSize="18px"
              url={this.props.avatar}
            />
          </SimpleLink>

          <div style={{ margin: '7px 16px 0' }}>
            <SimpleLink to={this.generatedPath}>
              <Name>{this.props.name}</Name>
            </SimpleLink>

            {this.props.socialLinks && (
              <SocialLinks socialLinks={this.props.socialLinks} />
            )}
          </div>
        </div>

        <div style={{ flex: '0 0 auto', marginLeft: 'auto', marginTop: '16px' }}>
          <Name as="span" style={{ fontWeight: '600', marginRight: '16px' }}>
            {this.props.amount} {this.props.currency === 'rub' ? '₽' : this.props.currency}
          </Name>

          {this.props.match.params.status === 'created' && (
            <React.Fragment>
              <PrimaryButton
                type="button"
                style={{ marginRight: '8px' }}
                onClick={this.handleProcessingClick}
                disabled={this.state.loading}
              >
                оплатить
              </PrimaryButton>

              <SecondaryButton
                type="button"
                onClick={this.handleRejectClick}
                disabled={this.state.loading}
                style={{ marginRight: '10px' }}
              >
                отклонить
              </SecondaryButton>
            </React.Fragment>
          )}

          <TransactionTooltip
            method={this.props.method}
            methodInfo={this.props.methodInfo}
          />
        </div>
      </UserItemRow>
    );
  }
}

UserRow.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  avatar: PropTypes.string,
  amount: PropTypes.string,
  currency: PropTypes.oneOf(['rub']),
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.string,
    socialLink: PropTypes.string,
  })),
  method: PropTypes.oneOf(['card', 'phone', 'yandex_wallet']),
  methodInfo: PropTypes.string,

  disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  onCheckboxChange: PropTypes.func,
  onStatusUpdate: PropTypes.func,

  userId: PropTypes.string,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      department: PropTypes.oneOf(['requests']).isRequired,
      status: PropTypes.oneOf(['created', 'processing,finished', 'rejected', 'failed,failed_by_notification']).isRequired,
    }).isRequired,
  }).isRequired,
};

UserRow.defaultProps = {
  id: '',
  name: '',
  avatar: '',
  socialLinks: [],
  amount: '0',
  method: 'card',
  methodInfo: '',
  currency: 'rub',

  isChecked: false,
  disabled: false,
  onCheckboxChange: () => {},
  onStatusUpdate: () => {},

  userId: undefined,
  history: {},
};

export default withRouter(UserRow);
